import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseuri from '../../baseuri';
import { randomgen } from '../../utils/general-utils';
import { addToLoadingQueue, removeFromLoadingQueue } from './general';

export const retrieveAdminBlacklistedWallets = createAsyncThunk(
	'adminBlacklistedWallets/retrieveAdminBlacklistedWallets',
	async (params: any, { dispatch }) => {
		const loadingId = randomgen();
		dispatch(addToLoadingQueue(loadingId));
		try {
			const res = await baseuri.get('/admin/blacklist-wallets/', { params });
			dispatch(removeFromLoadingQueue(loadingId));
			
			// Some APIs return res.data.data directly or nested
			const responseData = res.data.data;
			return responseData;
		} catch (error) {
			dispatch(removeFromLoadingQueue(loadingId));
			throw error;
		}
	}
);

export const retrieveSingleAdminBlacklistedWallet = createAsyncThunk(
	'adminBlacklistedWallets/retrieveSingleAdminBlacklistedWallet',
	async (id: string, { dispatch }) => {
		const loadingId = randomgen();
		dispatch(addToLoadingQueue(loadingId));
		try {
			const res = await baseuri.get('/admin/blacklist-wallets/single', {
				params: { id }
			});
			dispatch(removeFromLoadingQueue(loadingId));
			return res.data.data;
		} catch (error) {
			dispatch(removeFromLoadingQueue(loadingId));
			throw error;
		}
	}
);

const adminBlacklistedWalletsRx = createSlice({
	name: 'adminBlacklistedWallets',
	initialState: {
		blacklistedWallets: {
			itemsList: [],
			paginator: { currentPage: 1, itemCount: 0, perPage: 20 },
		},
		singleRecord: null,
		loading: false,
	},
	reducers: {},
	extraReducers: (builder) =>
		builder
			.addCase(retrieveAdminBlacklistedWallets.pending, (state) => {
				state.loading = true;
			})
			.addCase(retrieveAdminBlacklistedWallets.fulfilled, (state, action) => {
				const payload = action.payload;
				const itemsList = Array.isArray(payload) 
					? payload 
					: payload?.itemsList || payload?.items || payload?.data || [];
				
				const meta = payload?.paginator || payload?.meta || {};
				const itemCount = meta.itemCount || meta.total || payload?.totalCount || 0;
				const currentPage = meta.currentPage || 1;
				const perPage = meta.perPage || 20;

				state.blacklistedWallets = {
					itemsList,
					paginator: { currentPage, itemCount, perPage },
				};
				state.loading = false;
			})
			.addCase(retrieveAdminBlacklistedWallets.rejected, (state) => {
				state.loading = false;
			})
			.addCase(retrieveSingleAdminBlacklistedWallet.pending, (state) => {
				state.loading = true;
				state.singleRecord = null;
			})
			.addCase(retrieveSingleAdminBlacklistedWallet.fulfilled, (state, action) => {
				state.singleRecord = action.payload;
				state.loading = false;
			})
			.addCase(retrieveSingleAdminBlacklistedWallet.rejected, (state) => {
				state.loading = false;
			}),
});

export default adminBlacklistedWalletsRx.reducer;
